<template>
  <div> 
    <br><br>
    <div class="row  justify-content-center ">
        <div class="col-md-8">
            <br><br v-if="!isMobile">
            <h1 class="text-center" style="font-size: 30px; color: #50533A;"><b>GESTOR DE SOLICITUDES IDPDV</b></h1>
            <P class="text-center" style="font-size: 25px; color: #50533A;">Canal Especialista</P> 
            <center><u class="text-center" style="color: #019DF4; font-size: 17px; cursor: pointer;" v-if="registo_user == 1" @click="registo_user = 0">Regresar</u></center>
        </div> 
        <div class="col-md-12 mt-5">
            <template v-if="user.gestor_idpdv == 1">
                <template v-if="registo_user == 0">
                   <Listado2></Listado2> 
                </template>
                <template v-else>
                   <Registro></Registro> 
                </template>
            </template>
            <template v-else-if="user.gestor_idpdv == 2">
              <Listado ></Listado>
            </template>
        </div> 
    </div> 
  </div>
</template>
<script>  
import Listado2 from "./Listado2.vue"
import Listado from "./Listado.vue"
import Registro from "./Registro.vue"
export default {
    name:"home", 
    components:{
        Listado2, 
        Listado,
        Registro
    },
    data() {
        return {
          errors:[],
          loader:false, 
          isMobile: this.$mobile(),
          registo_user:0
        }
    },   
    computed:{
        user() {
            return this.$store.getters.getInfoUser;
        },
    },
    created(){
        this.$bus.$on("menuRegistrauser", () => {
            this.registo_user = 1;
        });

       this.$bus.$on("menuListadouser", () => {
            this.registo_user = 0;
        });

        this.$bus.$on("menuMuestra", () => {
            this.ocultar = 0;
        });

         this.$bus.$on("menuRegistro", () => {
            this.tips = 1; 
        });

        this.$bus.$on("menuRegistro2", () => { 
            this.tipo3 = 1;
        });

        this.$bus.$on("menuRegistroMarca", () => {
            this.tipM = 1; 
        });

        this.$bus.$on("menuOcultaMarca", () => {
            this.ocultarM = 1;
        });

        this.$bus.$on("menuMuestraMarca", () => {
            this.ocultarM = 0;
        });
     },
     mounted(){
        this.seccion = this.user.marca == 1 ? 0 : 2;
     }
}
</script>

<style>
  #redondo{
     border: 0.5px solid #77C23A;
     background: #77C23A;
     border-radius: 20px; 
  } 
  #redondo2{
     border: 0.5px solid #039cf3;
     background: #039cf3;
     border-radius: 20px; 
  } 
</style>